'use es6';

import { APP_INTEGRATIONS_REQUESTED, APP_INTEGRATIONS_RECEIVED, APP_INTEGRATIONS_FAILED } from './ActionTypes';
import * as ecosystemClient from '../clients/ecosystemClient';
export const fetchAppIntegrations = () => dispatch => {
  dispatch({
    type: APP_INTEGRATIONS_REQUESTED
  });
  return ecosystemClient.getAppIntegrations().then(data => {
    dispatch({
      type: APP_INTEGRATIONS_RECEIVED,
      payload: data.tags
    });
  }, error => {
    dispatch({
      type: APP_INTEGRATIONS_FAILED,
      error: true,
      payload: error
    });
  });
};